module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (gon.display_options.is_interactive) {;
__p += '\n<div id="desktop_view">\n	';
 if(lessThanFiveDropDowns()) { ;
__p += '\n	<div id="filters_container" class="four_or_less_elements"> \n	';
 } else { ;
__p += '\n	<div id="filters_container">\n	';
 } ;
__p += '\n		<div id="search_region" class="filter_wrapper" analytics-id="search"></div>\n		<div id="categories_region_1" class="filter_wrapper" analytics-id="category filter"></div>\n		<div id="categories_region_2" class="filter_wrapper" analytics-id="category filter"></div>\n		<div id="categories_region_3" class="filter_wrapper" analytics-id="category filter"></div>\n		<div id="personalization_region" class="filter_wrapper" analytics-id="personalization filter"></div>\n		<div id="seasons_region" class="filter_wrapper" analytics-id="month filter"></div>\n		<div id="location_region" class="filter_wrapper" analytics-id="location filter"></div>\n		<div id="sort_region" class="filter_wrapper" analytics-id="sort"></div>\n	</div>\n	<div id="map_region"></div>\n	<div id="results_bar_region"></div>\n</div>\n';
};


}
return __p
}